import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = { class: "mt-3 pt-1" }
const _hoisted_3 = {
  for: "category-active",
  class: "d-flex align-items-center cursor-pointer"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "d-block ms-2" }, "Active", -1)
const _hoisted_5 = { class: "mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AvatarUpload = _resolveComponent("AvatarUpload")!
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_AppInputsValidationProvider = _resolveComponent("AppInputsValidationProvider")!
  const _component_AppCheckbox = _resolveComponent("AppCheckbox")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    title: _ctx.title,
    opened: _ctx.opened,
    onHide: _ctx.hide
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.isShow)
            ? (_openBlock(), _createBlock(_component_AvatarUpload, {
                key: 0,
                modelValue: _ctx.editData.file,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editData.file) = $event)),
                placeholder: _ctx.editData.icon,
                onFileChanged: _ctx.fileUpload
              }, null, 8, ["modelValue", "placeholder", "onFileChanged"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_AppInputsValidationProvider, { onChangeErrorState: _ctx.onChangeErrorState }, {
            default: _withCtx(() => [
              _createVNode(_component_AppInput, {
                id: "create-category",
                modelValue: _ctx.editData.title,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editData.title) = $event)),
                "input-type": "material",
                label: "Title",
                type: "text",
                "validation-type": "notEmptyString",
                name: "image"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["onChangeErrorState"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("label", _hoisted_3, [
              _createVNode(_component_AppCheckbox, {
                id: "category-active",
                modelValue: _ctx.editData.active,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editData.active) = $event)),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editData.active = _ctx.isChecked))
              }, null, 8, ["modelValue"]),
              _hoisted_4
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_AppButton, {
            disabled: !_ctx.disabledButton,
            type: "secondary",
            size: "xl",
            loading: _ctx.loading,
            onClick: _ctx.submit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.title), 1)
            ]),
            _: 1
          }, 8, ["disabled", "loading", "onClick"])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["title", "opened", "onHide"]))
}